// Есть ли связь с сервером — по последнему запросу клиента API. Полоса «Нет связи» (T051) читает
// это состояние; тосты (без тостов об успехе в офлайне) — isOnline в момент показа (toasts.tsx).
import { useSyncExternalStore } from 'react';
import { isOnline, onConnectionChange } from '../api/client.ts';

export function useOnline(): boolean {
  return useSyncExternalStore(onConnectionChange, isOnline, () => true);
}
